<app-slider></app-slider>
<app-showcase></app-showcase>
<app-about-us></app-about-us>
<app-creative></app-creative>
<app-achievement></app-achievement>